import { Expose, Type } from "class-transformer";
import { ProfileCompletionDto } from "../../../../legacy/pages/Profile/dtos/profile-completion/profile-completion.dto";
import type { IProfileCompletionDto } from "../../../../legacy/pages/Profile/dtos/profile-completion/profile-completion.dto.interface";
import { ActivityDto } from "../../../../legacy/services/activity/dtos/activity/activity.dto";
import type { IActivityDto } from "../../../../legacy/services/activity/dtos/activity/activity.dto.interface";
import { HouseholdMemberWithAllDataDto } from "../../household/dto/household-member-with-all-data/household-member-with-all-data.dto";
import type { IHouseholdMemberWithAllDataDto } from "../../household/dto/household-member-with-all-data/household-member-with-all-data.dto.interface";
import { RealEstateDto } from "../../real-estate/dto/real-estate.dto";
import type { IProfileDto } from "./profile.dto.interface";

export class ProfileDto implements IProfileDto {
  @Expose()
  personaId!: string;

  @Expose()
  firstName!: string;

  @Expose()
  lastName!: string;

  @Expose()
  taxCode!: string;

  @Expose()
  birthDate!: string;

  @Expose()
  citizenship!: string[];

  @Expose()
  isHouseholdCompositionAsked!: boolean;

  @Expose()
  isHouseholdConfirmed?: boolean;

  @Expose()
  hasKnownIsee?: boolean;

  @Expose()
  hasDeclaredIncome?: boolean;

  @Expose()
  isIncomeConfirmed?: boolean;

  @Expose()
  isRealEstateConfirmed?: boolean;

  @Expose()
  @Type(() => ActivityDto)
  activities!: IActivityDto[];

  @Expose()
  @Type(() => HouseholdMemberWithAllDataDto)
  householdMembers!: IHouseholdMemberWithAllDataDto[];

  @Expose()
  lastUpdatedDate?: string;

  @Expose()
  accountId!: number;

  @Expose()
  pictureUrl?: string;

  @Expose()
  citizenId!: number;

  @Expose()
  migrationStartedAt?: string;

  @Expose()
  migrationCompletedAt?: string;

  @Expose()
  @Type(() => RealEstateDto)
  realEstates!: RealEstateDto[];

  @Expose()
  @Type(() => ProfileCompletionDto)
  completion!: IProfileCompletionDto;
}
